import { render, staticRenderFns } from "./hkpdf.vue?vue&type=template&id=5b2151ff&scoped=true"
import script from "./hkpdf.vue?vue&type=script&lang=js"
export * from "./hkpdf.vue?vue&type=script&lang=js"
import style0 from "./hkpdf.vue?vue&type=style&index=0&id=5b2151ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2151ff",
  null
  
)

export default component.exports